import * as React from "react"

import SecondarySidebarProductCollections from "components/sidebars/SecondarySidebarProductCollections"
import SecondarySidebarInternal from "components/sidebars/SecondarySidebarInternal"

// consumed by sidebar components to make sure absolute sizes don't get out of whack
export const PRIMARY_SIDEBAR_WIDTH = 250
export const SM_PRIMARY_SIDEBAR_WIDTH = 64
export const SECONDARY_SIDEBAR_WIDTH = 212

export const sidebarDefs = [
  {
    basePath: "/dashboard/product-research/collections",
    secondarySidebar: <SecondarySidebarProductCollections />,
  },
  {
    basePath: "/dashboard/internal",
    secondarySidebar: <SecondarySidebarInternal />,
  },
]
